export default {
    state: {
        selectBanshichuName: '',
        selectCommunityName: '',
        selectBanshichuCode: '',
        selectCommunityCode: '',

        fullAddress: '',
        tenantId: '',

        homeRedirct: ''
    },
    mutations: {
        setLocationInfo(state, locationInfo) {
            state.locationInfo = locationInfo
        }
    },
    actions: {
        setUserInfo({commit}, locationInfo) {
            commit('setLocationInfo', locationInfo)
        }
    }
}
